export default __webpack_public_path__ + "static/media/c005-whatsapp-01.117dbedb.png";